import SectionHeading from "./SectionHeading";
import { hotList, categories } from "@/mocks/chiGuaData";

const tagColor: Record<string, string> = {
  persona: "bg-primary-100 text-primary-800",
  filter: "bg-accent-100 text-accent-900",
  flip: "bg-secondary-100 text-secondary-900",
  crash: "bg-foreground-950 text-background-50",
  idol: "bg-primary-500 text-background-50",
};

export default function HotList() {
  return (
    <section id="week" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            index="01"
            en="This week · Hot"
            title="本周高能盘点"
            desc="按近 30 天讨论增量排序，把当下最响的几场「反差」一次刷完。热度只代表围观度，不代表是非对错。"
          />
          <a
            href="#contrast"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-100 px-4 py-2 text-sm font-semibold text-secondary-900 transition-colors hover:bg-secondary-200"
          >
            切到反差现场
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {hotList.map((item, i) => (
            <li
              key={item.title}
              className="group flex gap-4 rounded-xl border border-background-200/70 bg-background-100/70 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50 md:p-5"
            >
              <span className="section-index select-none font-heading text-5xl font-black leading-none text-foreground-200 group-hover:text-primary-500 md:text-6xl">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${
                      tagColor[item.tagId] || tagColor.crash
                    }`}
                  >
                    #{item.tagName}
                  </span>
                  <span className="flex items-center gap-1 text-xs font-semibold text-primary-600">
                    <i className="ri-fire-fill text-accent-500" />
                    {Math.round(item.heat / 1000)}k
                  </span>
                  <span className="ml-auto flex items-center gap-1 text-xs font-semibold text-secondary-700">
                    <i className="ri-arrow-up-line" />
                    {item.momentum}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.snippet}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-6 flex items-center gap-3 rounded-xl bg-foreground-950 px-4 py-4 text-sm text-background-100 md:px-5">
          <i className="ri-question-line rounded-full bg-accent-500/20 px-2 py-1 text-accent-400" />
          <p className="flex-1">
            榜单是怎样算出来的？围观度、物料流散范围与多平台讨论密度我们都会综合进口径里。
          </p>
          <a
            href="#faq"
            className="whitespace-nowrap text-xs font-semibold text-accent-400 hover:underline"
          >
            吃瓜FAQ →
          </a>
        </div>
      </div>
    </section>
  );
}